export default __webpack_public_path__ + "static/media/typecheck.cb7a46f4.png";